<template>
  <AnalyticsWidget
    title="Production Station Summary"
    subTitle="Production station with capacity summary details for today"
    :gridWidth="gridWidth"
    :gridHeight="gridHeight">

    <LoadingPanel :loading="loading" />
    <AnalyticsBreakdownTable v-if="!loading">
      <template v-slot:header>
        <tr>
          <th></th>
          <th><Tooltip label="Number of panels completed at this stage" helpStyle>Panels Completed</Tooltip></th>
          <th><Tooltip label="Number of panels due at this station today" helpStyle>Panels Pending</Tooltip></th>
          <th><Tooltip label="Total units completed today" helpStyle>Completed Units</Tooltip></th>
          <th><Tooltip label="Total units due today" helpStyle>Remaining Units</Tooltip></th>
          <th><Tooltip label="Units per hour expected to be completed at this station" helpStyle>Capacity / Hour</Tooltip></th>
          <th><Tooltip label="Current capacity percent completed up to now" helpStyle>Current Capacity</Tooltip></th>
          <th><Tooltip label="Capacity required for the remaining panels due today" helpStyle>Remaining Capacity Req.</Tooltip></th>
          
        </tr>
      </template>
      <template v-slot:body>
        <tr v-for="stationInfo of filteredStationList" :key="stationInfo.id">
          <td>
            <LinkProductionStation :id="stationInfo.id" :name="stationInfo.name" />
          </td>
          <td>{{stationInfo.completedTaskCount}}</td>
          <td>{{stationInfo.pendingTaskCount}}</td>
          <td><UOMValue :uomType="stationInfo.uomType" :value="stationInfo.completedCapacityUnits" /></td>
          <td><UOMValue :uomType="stationInfo.uomType" :value="stationInfo.pendingCapacityUnits" /></td>
          <td>
            <UOMValue :uomType="stationInfo.uomType" :value="stationInfo.capacityUnitsPerHour" v-if="stationHaveCapacitySupport(stationInfo)" />
            <span v-else>-</span>
          </td>
          <td>
            <span :class="classForStationCapacity(stationInfo.completedCapacityPercent)" v-if="stationHaveCapacitySupport(stationInfo)">{{formatPercent(stationInfo.completedCapacityPercent)}}</span>
            <span v-else>-</span>
          </td>
          <td>
            <span :class="classForStationCapacity(stationInfo.remainingCapacityPercent)" v-if="stationHaveCapacitySupport(stationInfo)">{{formatPercent(stationInfo.remainingCapacityPercent)}}</span>
            <span v-else>-</span>
          </td>
        </tr>
      </template>

    </AnalyticsBreakdownTable>
  </AnalyticsWidget>
</template>


<script>
import AnalyticsWidget from '@/modules/intelligence/components/analyticsWidget'
import AnalyticsBreakdownTable from '@/modules/intelligence/components/analyticsBreakdownTable'
import AnalyticsBreakdownValueCell from '@/modules/intelligence/components/analyticsBreakdownValueCell'

import { UOMTypeLookup } from '@/store/types'

export default {
  name: 'ProductionStationSummaryWidget',
  components: {
    AnalyticsWidget,
    AnalyticsBreakdownTable,
    AnalyticsBreakdownValueCell
  },
  props: {
    filter: Object,
    gridWidth: Number,
    gridHeight: Number
  },
  computed: {
    filteredStationList() {
      if(!this.stationSummaryData.stationCapacityList)
        return []

      // Hide stations with zero data
      return this.stationSummaryData.stationCapacityList.filter(stationInfo => {
        return (stationInfo.completedTaskCount > 0 || stationInfo.pendingTaskCount > 0)
      })
    }
  },
  data() {
    return {
      loading: true,
      stationSummaryData: {}
    }
  },
  watch: {
    filter: function() {
      this.requestData()
    }
  },
  created() {
    this.UOMTypeLookup = UOMTypeLookup
  },
  mounted() {
    this.loading = true
    this.requestData()

    this.subscribeEndpoint('/production/panelschedule', () => {
      this.requestData()
    })
  },
  beforeDestroy() {
    this.unsubscribeEndpoint('/production/panelschedule')
  },
  methods: {
    requestData() {
      var params = {
        accountLocationId: this.filter ? this.filter.accountLocationIdList : null,
      }

      this.$apiService.analyticsService.getProductionCapacitySummary(params)
      .then(response => {
        this.stationSummaryData = response.data
      })
      .finally(() => {
        this.loading = false
      })
      .catch(err => {
      })
    },
    classForStationCapacity(capacityValue) {
      if(capacityValue < 60)
        return 'result-fg-success'
      if(capacityValue < 85)
        return 'result-fg-notice'

      return 'result-fg-failed'
    },
    stationHaveCapacitySupport(stationInfo) {
      return !stationInfo.isDependentStationType
    }
  }
}
</script>